import { getAuthToken } from 'utils/auth';

export const API_BASE_URL = `${process.env.REACT_APP_BASE_URL_API}/api`;

export async function getMenuInfo(menuUuid: string) {
  const headers = {
    Authorization: `Bearer ${getAuthToken()?.accessToken}`,
  };

  const res = await fetch(`${API_BASE_URL}/v1/menu-maker/menu-template/menus/${menuUuid}/info/`, {
    method: 'GET',
    headers,
  });
  const data = await res.json();
  if (!res.ok || data.ok === false) {
    throw data.data;
  }
  return data;
}

export async function deleteMenu(menuUuid: string) {
  const headers = {
    Authorization: `Bearer ${getAuthToken()?.accessToken}`,
  };

  const res = await fetch(`${API_BASE_URL}/v1/menu-maker/menu-template/menus/${menuUuid}/`, {
    method: 'DELETE',
    headers,
  });
  const data = await res.json();
  if (!res.ok || data.ok === false) {
    throw data.data;
  }
  return data;
}
